import { CrudTable, StatusBadge } from "@/components/shared";

export default function Calls() {
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date?.slice(0, 10) },
    { key: "person", label: "By" },
    { key: "patient_name", label: "Patient" },
    { key: "branch", label: "Branch" },
    { key: "call_type", label: "Type", render: (r) => <StatusBadge value={r.call_type} /> },
    { key: "outcome", label: "Outcome", render: (r) => <StatusBadge value={r.outcome} /> },
    { key: "next_followup_date", label: "Next Follow-up", render: (r) => r.next_followup_date?.slice(0, 10) || "—" },
    { key: "remark", label: "Remark" },
  ];
  const fields = [
    { key: "date", label: "Date", type: "date" },
    { key: "patient_name", label: "Patient Name", type: "text" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "call_type", label: "Call Type", type: "select", options: ["Follow-up", "Due", "Upsell", "Cross-sell", "Feedback", "Review"] },
    { key: "outcome", label: "Outcome", type: "select", options: ["Connected", "Not picked", "Callback", "Booked", "Refused"] },
    { key: "next_followup_date", label: "Next Follow-up Date", type: "date" },
    { key: "remark", label: "Remark", type: "textarea", full: true },
  ];
  return (
    <CrudTable testid="calls" endpoint="calls" dateField="date"
      title="Calls / Follow-up Log"
      subtitle="Har call log karo — follow-up, due, upsell, feedback ya review. Outcome aur next follow-up date ke saath."
      columns={columns} fields={fields} defaults={{ call_type: "Follow-up", outcome: "Connected" }} />
  );
}
